<script setup lang='ts'>
import { FILE_GZ_HOST, addHost } from '@qctsw/common'
import { getUserScanDrivingApi } from '@/server'
import type { ScanDrivingResponse } from '@/server/types'

const props = withDefaults(defineProps<{
  modelValue?: string
}>(), {
  modelValue: '',
})
const emits = defineEmits({
  'update:modelValue': (data: string) => typeof data === 'string',
  'scanHandle': (_data: ScanDrivingResponse) => true,
})

const uploading = ref(false)
const tipsText = computed(() => {
  return uploading.value
    ? '图片上传中...'
    : props.modelValue ? '重新扫描行驶证' : '扫描行驶证'
})

async function scanDriving(picture: string) {
  useNotification.info({
    title: '提示',
    content: '图片识别中，请稍后...',
    duration: 0,
  })

  try {
    const res = await getUserScanDrivingApi(addHost(picture, FILE_GZ_HOST))
    useNotification.destroyAll()
    if (!res || !res.data) {
      useNotification.warning({
        title: '提示',
        content: '图片识别失败，未识别到有效信息，请更换图片后重试',
        duration: 0,
        closable: true,
      })
    }
    else { // 识别成功
      emits('update:modelValue', picture)
      emits('scanHandle', { ...res.data, drivingLicenseFrontImg: picture })
    }
  }
  catch (err) {
    recordError(err)
    useNotification.destroyAll()
    emits('update:modelValue', '')
    useNotification.error({
      title: '提示',
      content: getErrorMsg(err),
      duration: 0,
      closable: true,
    })
  }
}
function imageChangeHandler(data: string) {
  uploading.value = false
  if (data)
    scanDriving(data)
}
</script>

<template>
  <BasicUploadSingle :model-value="modelValue" @update:model-value="imageChangeHandler">
    <NPopover trigger="hover" placement="left">
      <template #trigger>
        <button class="bg-blue-5 rounded text-white px-sm py-1">
          {{ tipsText }}
        </button>
      </template>
      <div class="w-50 h-37.5">
        <NImage preview-disabled class="w-full h-full" src="/images/example.jpg" />
      </div>
      <div class="text-3 mt-2 text-slate-5 text-center">
        请确保内容清晰可见
      </div>
    </NPopover>
  </BasicUploadSingle>
</template>

<style lang='scss' scoped>

</style>
